import { Heading, Subtitle } from './PageHeading.styles';
import type { PageHeadingProps } from './PageHeading.types';

export function PageHeading({ title, subtitle, flush, centered, splitLines }: PageHeadingProps) {
  return (
    <Heading data-flush={flush ? 'true' : undefined} data-centered={centered ? 'true' : undefined}>
      {title}
      {subtitle && (
        <>
          {' '}
          <Subtitle data-block={splitLines ? 'true' : undefined}>{subtitle}</Subtitle>
        </>
      )}
    </Heading>
  );
}
